//src/admin/pages/AdminBestsellerProducts.js
import AdminProductsBase from "./AdminProductsBase";

export default function AdminBestsellerProducts() {
  return <AdminProductsBase filterType="bestseller" />;
}
